import module from 'fan/proyecto/module.js'

module.config(($stateProvider) => {
    $stateProvider.state('proyecto.colaboradores.idse.exportar', {
      url: '/idse/generar/{tipo_movimiento_id:int}?{clase}&{fecha_inicial:date}&{fecha_final:date}',
      data: {title: 'Generar IDSE'},
      reloadOnSearch: false,
      resolve: {
        tipoMovimientoId: ($stateParams) => $stateParams.tipo_movimiento_id,
        clase: ($stateParams) => $stateParams.clase,
        fechaInicial: ($stateParams) => $stateParams.fecha_inicial,
        fechaFinal: ($stateParams) => $stateParams.fecha_final,
      },
      views: {
        '@proyecto.colaboradores': {
          template: '<fan-proyecto-colaboradores-idse-exportar proyecto-id="idProyecto" tipo-movimiento-id="tipoMovimientoId" clase="clase" fecha-inicial="fechaInicial" fecha-final="fechaFinal"/>',
          controller: ($scope, idProyecto, tipoMovimientoId, clase, fechaInicial, fechaFinal) => {
            $scope.idProyecto = idProyecto
            $scope.tipoMovimientoId = tipoMovimientoId
            $scope.clase = clase
            $scope.fechaInicial = fechaInicial
            $scope.fechaFinal = fechaFinal
          },
        },
      },
    })
  },
)



// WEBPACK FOOTER //
// ./src/fan/proyecto/routes/proyecto/colaboradores/idse/exportar.js